import { DatePicker, Divider, Card } from "antd";
import { IoMdReturnLeft } from "react-icons/io";
import "./detail-bank-screen.scss";
import Button from "src/libraries/components/button/Button";

interface BankAccount {
  bankAccountId: string;
  name: string;
  address: string;
  provinceCode: string;
  districtCode: string;
  wardsCode: string;
  mccCode: string;
  fee: number;
  bankAccountNumber: string;
  bankCode: string;
  bankCurrencyCode: string;
  bankAccountName: string;
  bankCodeBranch: string;
}
interface DetailProps {
  data: any;
  handleCancel: () => void;
}
export const DetailBankScreen = ({ data, handleCancel }: DetailProps) => {
  return (
    <div>
      <div className="detail-bank-screen">
        <div className="back-bank">
          <Button
            className="back-button"
            background="#022e45"
            textColor="#FFF"
            borderColor="#022e45"
          >
            <div className="button-content" onClick={() => handleCancel()}>
              <i>
                <IoMdReturnLeft color="#fff" size={24} />
              </i>
              <p className="button-text">Quay lại</p>
            </div>
          </Button>
        </div>
        <div className="top-card">
          <Card
            cover={
              <div className="bank-card-header">
                <div className="bank-header-logo">
                  <img
                    alt="Bank logo"
                    loading="lazy"
                    src="https://img.bankhub.dev/rounded/mbbank.png"
                  />
                </div>
                <div className="bank-header-title">NGÂN HÀNG TMCP QUÂN ĐỘI</div>
                <div className="bank-header-more">...</div>
              </div>
            }
          >
            <div>
              <div className="detail-bank-column">
                <div>Thông tin/ Mã thẻ</div>
                <div>Phương thức kết nối</div>
                <div>Tổng doanh thu</div>
                <div>Tổng đơn hàng</div>
                <div>Trạng thái</div>
              </div>

              <div className="detail-bank-container">
                {
                  <div>
                    <Card hoverable className="detail-bank-card">
                      <div className="detail-item">
                        <div>{data.bankAccountName}</div>
                        <div>VietQR Pro</div>
                        <div>{data.bankAccountNumber}</div>
                        <div>1000</div>
                        <div>
                          <div className="account-state">
                            <div style={{ width: "100%" }}>Đang liên kết</div>
                          </div>
                        </div>
                      </div>
                    </Card>
                  </div>
                }
              </div>
            </div>
          </Card>
        </div>
        <div className="channel-title">Kênh thanh toán</div>
        <div className="account-container">
          {[1, 2, 3, 4].map((index, item) => (
            <Card
              //   onClick={() => handleViewDetailBankScreen(value)}
              hoverable
              className="account-card"
              key={index}
            >
              <div className="account-item">
                <div className="account-img">
                  <img
                    alt="Bank logo"
                    loading="lazy"
                    src="https://img.bankhub.dev/rounded/mbbank.png"
                  />
                </div>
                <div className="account-name">
                  <div className="account-merchant">
                    {/* {value.bankAccountName} */}
                  </div>
                  {/* <div className="account-id">{value.bankAccountId}</div> */}
                </div>
                <div className="account-state">
                  <div>Đang liên kết</div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};
